import React, { useCallback, useEffect, useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from './MLPhoneNumberComponent.metadata.json5';
import styles from './MLPhoneNumberComponent.module.scss';
import './MLPhoneNumberComponent.messages';
import { useTranslator } from '@jutro/locale';
import messages from './MLPhoneNumberComponent.messages'

function MLPhoneNumberComponent(props) {
    const {
        contactVM, updateContactVM, id: componentId, showValidationErrors, submissionVM
    } = props;
    const { isComponentValid, registerComponentValidation } = useValidation(componentId);
    const inputRef = useRef(null);
    const cursorLockRef = useRef(null);

    const translator = useTranslator();
    
    const homeNumberIsValid = useCallback(() => {
        const homeNumberValid = _.get(contactVM, 'homeNumber.aspects.valid');
        const homeNumberSubtreeValid = _.get(contactVM, 'homeNumber.aspects.subtreeValid');
        const homeNumberNotEmpty = !_.isEmpty(_.get(contactVM, 'homeNumber.value'));
        return homeNumberValid && homeNumberSubtreeValid && homeNumberNotEmpty;
    }, [contactVM]);
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';

    useEffect(() => {
        registerComponentValidation(homeNumberIsValid);
    }, [registerComponentValidation, homeNumberIsValid]);

    const updateToUnmaskedPhoneNum = useCallback((value) => {
        const unmaskedPhoneNumber = value.replace(/[^\d]/g, '');
        _.set(contactVM, 'homeNumber.value', unmaskedPhoneNumber);

        updateContactVM(contactVM);
    }, [contactVM, updateContactVM, isComponentValid]);

    const onValueChange = (value, path) => {
        _.set(contactVM, path, value);
        updateContactVM(contactVM);
    };

    const isQuoted = (quoteNumber) => {
        if (!quoteNumber) return false;
        const list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY) || '[]');
        return list.includes(quoteNumber);
    };

    const isQuoteAndBuy = _.get(submissionVM, 'baseData.portalCode_ML.value') === "QB"

    const handlePhoneFocus = (event) => {
        const input = event.target;
        inputRef.current = input;

        const isEmpty = input.value.replace(/[#()\s-]/g, "") === "";

        if (isEmpty) {
            const firstEditableIndex = input.value.indexOf("#");
            input.setSelectionRange(firstEditableIndex, firstEditableIndex);

            cursorLockRef.current = setInterval(() => {
                if (!inputRef.current) return;

                const raw = inputRef.current.value.replace(/[#()\s-]/g, "");

                if (raw) {
                    clearInterval(cursorLockRef.current);
                    cursorLockRef.current = null;
                    return;
                }

                if (inputRef.current.selectionStart !== firstEditableIndex) {
                    inputRef.current.setSelectionRange(firstEditableIndex, firstEditableIndex);
                }
            }, 10);
        }
    };

    const handlePhoneBlur = () => {
        if (cursorLockRef.current) {
            clearInterval(cursorLockRef.current);
            cursorLockRef.current = null;
        }
    };
 
    const overrideProps = {
        phoneNumber: {
            onValueChange: updateToUnmaskedPhoneNum,
            required: isQuoteAndBuy,
            disabled: isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))),
            label: isQuoteAndBuy ? translator(messages.phoneNumber) : translator(messages.preferredPhoneNumber),
            onFocus: handlePhoneFocus,
            onBlur: handlePhoneBlur
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={contactVM}
            overrideProps={overrideProps}
            onValueChange={onValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showValidationErrors}
        />
    );
}

MLPhoneNumberComponent.propTypes = {
    contactVM: PropTypes.shape({}).isRequired,
    updateContactVM: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
};

export default MLPhoneNumberComponent;
